import * as React from 'react';
import classnames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import TileSizeContext from '../../context/TileSizeContext';

import type { TileStandardSize } from 'types';

import './tile-standard-header-chevron.scss';

import type { SyntheticEvent } from 'react';

type Props = {
  onResize: (a: TileStandardSize) => void
};

const TileStandardHeaderChevron = (
  {
    onResize
  }: Props
): JSX.Element => {
  const tileSize = React.useContext(TileSizeContext);

  const chevronClasses = classnames('tile-standard-header-chevron', {
    [`tile-standard-header-chevron--size-${tileSize}`]: Boolean(tileSize)
  });

  const handleResize = (event: SyntheticEvent<HTMLElement>): void => {
    const target = event.currentTarget;
    const isExpanded = target.dataset.tileSize === 'expanded';

    onResize(isExpanded ? 'collapsed' : 'expanded');
  };

  return (
    <div
      className={chevronClasses}
      onClick={handleResize}
      data-tile-size={tileSize}
    >
      <SVGDynamicIcon
        name="chevron-down-custom-fg"
        width={15}
        height={8}
        customColor="grey"
        clickable
      />
    </div>
  );
};

export default TileStandardHeaderChevron;
